import { createFileRoute } from '@tanstack/react-router'
import Footer from '../components/landing/Footer'
import "./legal.css"

export const Route = createFileRoute('/contact')({
  component: ContactPage,
})

function ContactPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Contact Us</h1>
        
        <div className="legal-intro">
          <p>
            We'd love to hear from you. Reach out to us for any queries, support, or partnership opportunities.
          </p>
        </div>

        <div className="legal-section">
          <h2>Our Office</h2>
          <p>
            <strong>Modulus Sell</strong><br/>
            7th Cross, Tavarekere Main Road,<br/>
            BTM 1st Stage,<br/>
            Bengaluru, Karnataka 560029
          </p>
        </div>

        <div className="legal-section">
          <h2>Get in Touch</h2>
          <p>
            <strong>General Inquiries:</strong><br/>
            <a href="mailto:sarfarazahmedkl@modulusseventeen.com">sarfarazahmedkl@modulusseventeen.com</a>
          </p>
          <p>
            <strong>Direct Contact:</strong><br/>
            <a href="mailto:sarfarazahmedkl@modulusseventeen.com">sarfarazahmedkl@modulusseventeen.com</a><br/>
            <a href="tel:+917356001171">+91 735600 1171</a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
